import { WWOTopReferringWebsitesTable } from "app/pages/website-performance/components/TopReferringWebsites/WWOTopReferringWebsitesTable";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTopReferringWebsitesContainerSI = ({ hideFooter = false }: { hideFooter?: boolean }) => {
    const params = proNavigator.getParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("accountreview_website_referrals_incomingtraffic", params),
            target: "_self",
        };
    };
    return (
        <WWOTopReferringWebsitesTable
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WebReferralIncomingTraffic",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
            hideFooter={hideFooter}
        />
    );
};
